import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import ReportSection from '@/_core/entities/report/ui/ReportSection/ReportSection.vue';
import Accordion from '@/_core/shared/ui/Accordion/Accordion.vue';
import TrialOverlay from '@/_core/entities/vulnerability/ui/TrialOverlay/TrialOverlay.vue';
import ExpandToggleButton from '@/_core/shared/ui/ExpandToggleButton/ExpandToggleButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LlmSummaryPair',
  props: {
    hasLeft: { type: Boolean, default: false },
    hasRight: { type: Boolean, default: false },
    leftTrialTitle: { default: '' },
    rightTrialTitle: { default: '' },
    isLeftContentUnlocked: { type: Boolean, default: true },
    isRightContentUnlocked: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { hasLeft: boolean, hasRight: boolean, leftTrialTitle: string, rightTrialTitle: string, isLeftContentUnlocked: boolean, isRightContentUnlocked: boolean };



// Shared expand/collapse state for the xl+ single-panel layout.
const isSharedExpanded = ref(false);
const isLeftOverflowing = ref(false);
const isRightOverflowing = ref(false);
const isAnyOverflowing = computed(() => isLeftOverflowing.value || isRightOverflowing.value);

// Use a 2-col grid only when both cards are present so the row keeps equal-height
// cells regardless of content length. Fall back to a single column otherwise.
const desktopGridColsClass = computed(() =>
  props.hasLeft && props.hasRight ? 'tw:grid-cols-2' : 'tw:grid-cols-1'
);

return { __sfc: true,props, isSharedExpanded, isLeftOverflowing, isRightOverflowing, isAnyOverflowing, desktopGridColsClass, ReportSection, Accordion, TrialOverlay, ExpandToggleButton }
}

})